import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { consultants, CONSULTANT_DRAFT_NOTICE } from '../../data/consultants';
import { ConsultantPortrait } from '../../components/consultants/ConsultantPortrait';
import { ConsultantCard } from '../../components/consultants/ConsultantCard';
import { Button } from '../../components/ui/Button';
import { NotFound } from '../NotFound';
export function ConsultantProfile() {
  const {
    slug
  } = useParams();
  const c = consultants.find(x => x.slug === slug);
  usePageMeta(c ? `${c.name} — ${c.title}` : 'Consultant not found', c ? `${c.name}, ${c.title} at Corventa Talent Search. ${c.focus}.` : 'Profile not found.');
  if (!c) return <NotFound data-id="element-828" data-mp="l8egqafd5ef4" />;
  const others = consultants.filter(x => x.slug !== c.slug);
  return <>
      <section className="bg-midnight py-14 text-white md:py-20" data-id="element-829" data-mp="h5ry904l15ul">
        <div className="container-page" data-id="element-830" data-mp="h8nv0l4p1ohg">
          <Link to="/consultants" className="inline-flex items-center gap-1 text-sm text-white/70 hover:text-gold-300" data-id="element-831" data-mp="28asg1lw0mtml">
            <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-832" data-mp="2d8tz46tfysy2" />
            All consultants
          </Link>
          <div className="mt-10 grid gap-10 md:grid-cols-12 md:items-end" data-id="element-833" data-mp="1za3zajf8mf60">
            <div className="md:col-span-4" data-id="element-834" data-mp="23axkh51apfv7">
              <ConsultantPortrait initials={c.initials} name={c.name} className="rounded-xl" data-id="element-835" data-mp="23dtnh7s02uqi" />
            </div>
            <div className="md:col-span-8" data-id="element-836" data-mp="1ubal0os4mk4s">
              <p className="text-sm text-gold-300" data-id="element-837" data-mp="1uc2ik55aarxp">{c.title}</p>
              <h1 className="mt-2 font-display text-5xl font-semibold md:text-6xl" data-id="element-838" data-mp="1fmo3qhixviax">{c.name}</h1>
              <p className="mt-4 text-lg text-white/75" data-id="element-839" data-mp="1kl7t6rwqrc81">{c.focus}</p>
              <div className="mt-8 flex flex-wrap gap-3" data-id="element-840" data-mp="1kjemxdq1iu0k">
                <Button to={`/contact?pathway=executive&consultant=${c.slug}`} size="lg" arrow data-id="element-841" data-mp="16mreadoq6fet">
                  Contact {c.name.split(' ')[0]}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-ivory py-20" data-id="element-842" data-mp="3dbtf17vhzgwq">
        <div className="container-page grid gap-12 lg:grid-cols-12" data-id="element-843" data-mp="38i7a61vkshbh">
          <div className="lg:col-span-7" data-id="element-844" data-mp="33jvz5ntjo0ro">
            <p className="rounded-md border border-gold/40 bg-gold-100 px-4 py-3 text-sm text-gold-700" data-id="element-845" data-mp="33kyqfwus4584">{CONSULTANT_DRAFT_NOTICE}</p>
            <h2 className="mt-10 font-display text-3xl font-semibold text-ink" data-id="element-846" data-mp="2zgqy7pp44755">Biography</h2>
            {c.bio.map(p => <p key={p} className="mt-4 text-lg leading-relaxed text-muted" data-id="element-847" data-mp="3r9ztt5or8q6j">
                {p}
              </p>)}
            <h2 className="mt-10 font-display text-3xl font-semibold text-ink" data-id="element-848" data-mp="3n73blg34mw34">Professional approach</h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-849" data-mp="3i8a17wj4zl76">{c.approach}</p>
          </div>
          <aside className="space-y-8 lg:col-span-5" data-id="element-850" data-mp="2btr5eyjwa1ds">
            <div className="rounded-xl bg-white p-6" data-id="element-851" data-mp="26u67mrggnz2n">
              <h2 className="font-medium text-ink" data-id="element-852" data-mp="26sbnhfd0kazm">Search specialisations</h2>
              <ul className="mt-4 flex flex-wrap gap-2" data-id="element-853" data-mp="mcwzx4fw8xj7">
                {c.specializations.map(s => <li key={s} className="rounded border border-line px-3 py-1.5 text-sm text-ink" data-id="element-854" data-mp="rbqhp927rap6">
                    {s}
                  </li>)}
              </ul>
              <h2 className="mt-8 font-medium text-ink" data-id="element-855" data-mp="103ikcxkzxfj7">Industry expertise</h2>
              <ul className="mt-4 flex flex-wrap gap-2" data-id="element-856" data-mp="152lq6k8svps8">
                {c.industries.map(s => <li key={s} className="rounded bg-midnight px-3 py-1.5 text-sm text-white" data-id="element-857" data-mp="1a0x2d1mkicdm">
                    {s}
                  </li>)}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      <section className="bg-white py-20" data-id="element-858" data-mp="1j1l5v2ec4uc9">
        <div className="container-page" data-id="element-859" data-mp="3grw9l52tsg3p">
          <h2 className="font-display text-4xl font-semibold text-ink" data-id="element-860" data-mp="3gt7mpvi5v07h">Other consultants</h2>
          <div className="mt-10 grid gap-6 sm:grid-cols-3" data-id="element-861" data-mp="3kuj1t73es31f">
            {others.map(o => <ConsultantCard key={o.slug} consultant={o} data-id="element-862" data-mp="2pi9ugk8d2hvc" />)}
          </div>
        </div>
      </section>
    </>;
}